module.exports = __webpack_public_path__ + "media/images/material-6f3c3598e7485416a9bc1d4525def36f.png";